export var productVariantsMapper = function (item) {
    return item.variants.map(function (variantData) { return ({
        _id: variantData.id,
        choices: variantData.choices,
        variant: variantData.variant
            ? {
                currency: variantData.variant.priceData.currency,
                price: variantData.variant.priceData.price,
                discountedPrice: variantData.variant.priceData.discountedPrice,
                pricePerUnit: variantData.variant.priceData.pricePerUnit,
                formattedPrice: variantData.variant.priceData.formatted.price,
                formattedDiscountedPrice: variantData.variant.priceData.formatted.discountedPrice,
                formattedPricePerUnit: variantData.variant.priceData.formatted.pricePerUnit,
                weight: variantData.variant.weight,
                sku: variantData.variant.sku,
                visible: variantData.variant.visible,
            }
            : undefined,
    }); });
};
export var productVariantsParamMapper = function (item) { return ({
    choices: item.choices,
    variantIds: item.variantIds,
    paging: item.paging
        ? {
            limit: item.paging.limit,
            offset: item.paging.skip,
        }
        : undefined,
}); };
export var productVariantsUpdatedMapper = function (item) {
    return {
        productId: item.productId,
        variants: item.variants.map(function (variant) { return ({
            variantId: variant.variantId,
            choices: variant.choices,
            updatedFields: variant.changedFields,
        }); }),
    };
};
//# sourceMappingURL=productVariants.mapper.js.map